<template>
   <v-dialog v-model="isVisible" persistent max-width="1000">
        <v-toolbar dark color="primary" >
            <v-toolbar-title class="white--text" >Edit filter</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="close">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card >
            <v-card-text>
               <v-data-table
                  v-bind:headers="headers"
                  :items="adminOrderhistoryFilters"
                  hide-actions>
                  <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                     <td>{{ props.item.user.map(user => user.username).join(', ') }}</td>

                      <td class=" justify-center layout px-0">
    
                          <v-icon
                              small
                              @click="deleteItem(props.item)">
                              delete
                          </v-icon>
                      </td>
                  </template>
                </v-data-table>
            </v-card-text>
             <v-card-actions>
<!--         
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    flat="flat"
                    @click="close">
                    Cancel
                </v-btn>
                <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="save()">
                    Save
                </v-btn> -->
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import ArticleList from './ArticleList'
import AddressBox from './AddressBox'
import PaymentInfoBox from './PaymentInfoBox'

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    filter: {
      type: Object,
     //  required: true
    }
  },
  components: {
    ArticleList,
    AddressBox,
    PaymentInfoBox
  },
  data() {
    return {
        headers: [
            {
                text: 'Filter name',
                sortable: false
            },
            {
                text: 'Users',
                align: 'left',
                sortable: false
            },
            {
                text: 'Options',
                align: 'right',
                sortable: false
            }
        ]
    }
  },
  computed: {
    ...mapGetters([
      'adminOrderhistoryFilters',
      'user'
    ])
  },
  methods: {
    close () {
      this.$emit('close')
    },
    deleteItem (item) {
        this.$store.dispatch('deleteOrderhistoryFilter', item._id)
            .then(() => {
                this.$store.dispatch('getOrderhistoryFiltersForUser')
                if (this.user.isAdmin) {
                    this.$store.dispatch('getAdminOrderhistoryFilters')
                }
            })

    },

  },
  created () {
		//  const pivotGrid = this.$refs.grid.instance
		// this.$store.dispatch('getUsers')
	}
}
</script>
